import WithGASetup from '../../../components/WithGASetup';
import AuthContext from '../../../context/AuthContext.js';
import CalendlyAvailabilityPage from './CalendlyAvailabilityPage.js';

export default WithGASetup(CalendlyAvailabilityPage, AuthContext);
